/**
 * Compatibility for the original fontawesome react component name
 */

import { type IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeSvgIcon } from 'react-fontawesome-svg-icon';

export type { IconDefinition };
export { FontAwesomeSvgIcon as FontAwesomeIcon };
export default FontAwesomeSvgIcon;
